export default __webpack_public_path__ + "static/gallery-img5-c27255f330cacb89035f035dcea057e5.jpg";